module.exports = __webpack_public_path__ + "img/dy.b0b76ec2.png";